"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateRangeStepToMillis = void 0;
var MULTIPLIERS = {
    year: 8760 * 60 * 60 * 1000,
    month: 43800 * 60 * 1000,
    week: 7 * 24 * 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000,
    millisecond: 1,
};
function dateRangeStepToMillis(step) {
    return step.amount * MULTIPLIERS[step.unit];
}
exports.dateRangeStepToMillis = dateRangeStepToMillis;
//# sourceMappingURL=dateRangeStepToMillis.js.map